import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NiveauQualification } from 'src/app/shared/models/niveauQualification';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class NiveauQualificationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllNiveauQualification(): Observable<NiveauQualification[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.niveauQualificationUrl}/all`,
			'getAllNiveauQualification'
		);
	}

	importNiveauQualification(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'niveauQualification.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.niveauQualificationUrl}/import`,
			`importNiveauQualification`,
			formData
		);
	}

	getNiveauQualificationById(id: number): Observable<NiveauQualification> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.niveauQualificationUrl}/get/${id}`,
			'getNiveauQualificationById'
		);
	}

	updateNiveauQualification(niveauQualification: NiveauQualification): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.niveauQualificationUrl}/update/${niveauQualification.id}`,
			'updateNiveauQualification',
			niveauQualification
		);
	}

	addNiveauQualification(niveauQualification: NiveauQualification): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.niveauQualificationUrl}/add`,
			'addNiveauQualification',
			niveauQualification
		);
	}

	deleteNiveauQualification(niveauQualificationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.niveauQualificationUrl}/delete/${niveauQualificationId}`,
			`deleteNiveauQualification`
		);
	}
}
